// extracted by mini-css-extract-plugin
module.exports = {"mmboostpage":"style_mmboostpage__33BJ-","mmboostpage__calculator":"style_mmboostpage__calculator__2Ig8I","mmboostpage__button":"style_mmboostpage__button__1nSUE"};